import { updateObject } from 'utils/updateObject'
import { CLOSE_SIDE_PANEL, OPEN_SIDE_PANEL } from 'modules/SidePanel/store/types'

const initialState = {
  activeId: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_SIDE_PANEL:
      return updateObject(state, {
        activeId: action.payload?.id ?? null,
      })
    case CLOSE_SIDE_PANEL:
      return initialState
    default:
      return state
  }
}
